import ProductItem from "../../components/ProductItem";
import { MagnifyingGlass } from "@phosphor-icons/react";
import useProducts from "../../hooks/useProducts";
import { HashLoader } from "react-spinners";
import { useState } from "react";
import useMerchants from "../../hooks/useMerchants";
import MerchantItem from "../../components/marketplace/MerchantItem";
import { Link } from "react-router-dom";

const Explore = () => {
  const { products, isLoading: isLoadingProducts } = useProducts();
  const { merchants, isLoading: isLoadingMerchants } = useMerchants({
    page: 1,
    perPage: 50,
  });
  const [typeFilter, setTypeFilter] = useState<
    "all" | "merchants" | "products"
  >("all");

  const merchantItems = merchants.slice(0, 12);
  const productItems = (products?.data ?? []).slice(0, 12);
  const showMerchants = typeFilter !== "products";
  const showProducts = typeFilter !== "merchants";

  return (
    <div className="p-10 px-5 md:px-10 flex flex-col gap-10">
      <div className="flex flex-col gap-2">
        <h1 className="text-4xl font-medium">Marketplace</h1>
        <div className="text-gray-500">
          Discover products and merchants on the marketplace.
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 px-4 border border-gray-300 shadow rounded-lg focus-within:outline w-full max-w-72">
          <MagnifyingGlass size={20} />
          <input
            placeholder="Search products/merchants"
            name="search"
            type="search"
            className="focus:outline-none py-3 text-sm w-full"
          />
        </div>
        <div className="border border-gray-300 rounded-lg flex items-center px-2 text-xs md:text-sm p-3">
          <select
            className="flex-1 focus:outline-none"
            value={typeFilter}
            onChange={(event) =>
              setTypeFilter(
                event.target.value as "all" | "merchants" | "products"
              )
            }
          >
            <option value="all">All</option>
            <option value="merchants">Merchants</option>
            <option value="products">Products</option>
          </select>
        </div>
      </div>
      {showMerchants && isLoadingMerchants ? (
        <div className="py-20 flex items-center justify-center flex-col gap-5">
          <HashLoader size={30} />
          <div className="text-sm animate-pulse text-center">
            Loading Merchants
          </div>
        </div>
      ) : (
        showMerchants &&
        merchantItems.length > 0 && (
          <div className="flex flex-col gap-4">
            <div className="font-medium text-lg">Merchants</div>
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-5 md:gap-10">
              {merchantItems.map((merchant, key) => {
                return <MerchantItem merchant={merchant} key={key} />;
              })}
            </div>
            <Link
              to="/marketplace/merchants"
              className="hover:underline w-fit p-4 px-5 border-visaro-gray-700 border rounded-lg font-bold bg-deepBlue text-white text-sm flex-1 flex items-center justify-center"
            >
              View all merchants &rarr;
            </Link>
          </div>
        )
      )}
      {showProducts && isLoadingProducts ? (
        <div className="py-20 flex items-center justify-center flex-col gap-5">
          <HashLoader size={30} />
          <div className="text-sm animate-pulse text-center">
            Loading Products
          </div>
        </div>
      ) : (
        showProducts && (
          <div className="flex flex-col gap-4">
            <div className="font-medium text-lg">New Products</div>
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-5 md:gap-10">
              {productItems.map((product, key) => {
                return <ProductItem product={product} key={key} />;
              })}
            </div>
            <Link
              to="/marketplace/products"
              className="hover:underline w-fit p-4 px-5 border-visaro-gray-700 border rounded-lg font-bold bg-deepBlue text-white text-sm flex-1 flex items-center justify-center"
            >
              View all products &rarr;
            </Link>
          </div>
        )
      )}
    </div>
  );
};

export default Explore;
